import Vue from "vue";

export default {
  recuperarEspecificacoesProcesso() {
    return Vue.axios.get("especificacaoProcesso");
  },
};